export function obterListaCteTipo() {
  return (
    [
      { label: '0 - CTe Normal', value: 'NORMAL' },
      { label: '1 - CTe Complemento de Valores', value: 'COMPLEMENTO' },
      { label: '3 - CTe Substituição', value: 'SUBSTITUICAO' },
    ]
  );
}
